import React, { useState, useContext } from "react";
import Button from "@mui/material/Button";
import { Divider, CircularProgress } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import ModalForms from "./ModalForms";
import { DialogStyle } from "../../styles/pages/ContentStudio/WithStylesObjs";
import "../../styles/pages/ContentStudio/DynDialogue.scss";
import ValueContext from "../../ContextAPi/appContext";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
function DynDialogue(props) {
  const appData = useContext(ValueContext);
  const { t } = useTranslation();
  const {
    handleBussinessRulesModal,
    activeCard,
    setActiveCard,
    toggleCards,
    setToggleCards,
    cautionBackbtn,
    setResponseData,
    responseData,
    setCantExistCards,
    cantExistCards,
    setSelectedCardCaution,
    selectedCardCaution,
    setCautionBackbtn,
    linkedModulesType,
    handleVeevaContentModal,
    veevaLoader,
    values,
    setValues,
    openBusinessRules,
    backButtonClicked,
    setBackButtonClicked,
  } = props;

  var pFields = [];
  if (props.genericInfo) {
    pFields = [
      props.genericInfo.brand,
      props.genericInfo.campaign,
      props.genericInfo.market,
    ];
  }

  const [searchFlag, setsearchFlag] = useState(false);
  const [conflictsNumber, setConflictsNumber] = useState(0);
  const HandleSelect = (id, moduleId, classes) => {
    let tempcantExistCards = [];
    var tempActiveCards = JSON.parse(JSON.stringify(activeCard));
    let actFoundCardIndex = tempActiveCards.moduleId.indexOf(moduleId);
    if (actFoundCardIndex > -1) {
      tempActiveCards.moduleId.splice(actFoundCardIndex, 1);
    } else {
      tempActiveCards.moduleId.push(moduleId);
    }

    let tempToggleCards = [...toggleCards];
    let foundCardIndex = tempToggleCards.indexOf(moduleId);
    if (foundCardIndex > -1) {
      tempToggleCards.splice(foundCardIndex, 1);
    } else {
      tempToggleCards.push(moduleId);
    }
    appData &&
      appData.cardData.cards.forEach((temp) => {
        if (
          tempActiveCards.moduleId?.indexOf(temp.id) > -1 &&
          temp?.cannotExistRuleList?.length > 0
        ) {
          tempcantExistCards.push(...temp?.cannotExistRuleList);
        }
      });

    let conflictsNumber = 0;
    //Business Rule for conflicts checking .

    tempActiveCards.moduleId.forEach((cardNumber, index) => {
      if (tempcantExistCards.indexOf(cardNumber) > -1)
        conflictsNumber = conflictsNumber + 1;
    });
    setConflictsNumber(conflictsNumber);
    setToggleCards(tempToggleCards);
    setActiveCard(tempActiveCards);
    setCantExistCards(tempcantExistCards);
    setSelectedCardCaution(true);
  };

  const protectedFieldNames = [
    "Product/Brand",
    "Campaign",
    "Market",
    "Banner Name",
    "Tags",
  ];

  const { classes } = props;
  return (
    <>
      <Dialog
        className={`selectModalConatiner ${classes.root}`}
        open={props.open}
        onClose={() => props.handleClose(setActiveCard)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {veevaLoader && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress
              size="30px"
              className="customLoadermodules"
            />{" "}
          </>
        )}
        <div className="container no-gutters">
          <div className="row align-items-center align-left">
            <div className="col-md-4 selectModalTitle">
              {t("modulesLeftContainer.selectmodule")}
            </div>
            <div className="col-md-8">
              <ul className="moduleBrandDetails align-li">
                {pFields.map(
                  (valueAry, index) =>
                    protectedFieldNames[index] !== "Banner Name" &&
                    protectedFieldNames[index] !== "Tags" && (
                      <li>
                        <span>{protectedFieldNames[index]}</span>
                        <Tooltip title={valueAry}>
                          <h6 className="overFlow">{valueAry}</h6>
                        </Tooltip>
                      </li>
                    ),
                )}
              </ul>
            </div>
          </div>
        </div>

        <DialogContent className="search-cards">
          <ModalForms
            values={values}
            setValues={setValues}
            conflictsNumber={conflictsNumber}
            setConflictsNumber={setConflictsNumber}
            setActiveCard={setActiveCard}
            activeCard={activeCard}
            HandleSelect={HandleSelect}
            cantExistCards={cantExistCards}
            setsearchFlag={setsearchFlag}
            setSearchORRecent={props.setSearchORRecent}
            cannotExist={cantExistCards}
            setCantExistCards={setCantExistCards}
            setToggleCards={setToggleCards}
            setResponseData={setResponseData}
            responseData={responseData}
            selectedCardCaution={selectedCardCaution}
            setCautionBackbtn={setCautionBackbtn}
            cautionBackbtn={cautionBackbtn}
            setSelectedCardCaution={setSelectedCardCaution}
            linkedModulesType={linkedModulesType}
            openBusinessRules={openBusinessRules}
            backButtonClicked={backButtonClicked}
            setBackButtonClicked={setBackButtonClicked}
          />
        </DialogContent>
        <Divider className="action-Divider" />
        <DialogActions className="action-btn">
          <Button
            onClick={() => props.handleClose(setActiveCard)}
            color="primary"
            className="closeBtn"
          >
            {t("modulesLeftContainer.close")}
          </Button>
          {conflictsNumber > 0 && (
            <div className="conflict-mssg">
              {conflictsNumber} Conflict detected. This can result in compliance
              issues.{" "}
            </div>
          )}
          <Button
            onClick={() => {
              linkedModulesType === "nextModule"
                ? handleBussinessRulesModal()
                : handleVeevaContentModal();
              setCautionBackbtn(false);
            }}
            type="submit"
            disabled={activeCard.moduleId.length > 0 ? false : true}
            className="btn btn-primary proceed-btn "
            autoFocus
          >
            {t("modulesLeftContainer.proceed")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default withStyles(DialogStyle)(DynDialogue);
